var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state)?_c('div',[_c('i',{class:_vm.icon})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }